export default __webpack_public_path__ + "static/media/pigz.ba04288f.svg";